import React from 'react';
import { Tooltip, TooltipProps, styled } from '@mui/material';

/**
 * Custom Tooltip component with white background and black text
 */
const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    backgroundColor: '#FFFFFF',
    color: '#000000',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
    fontSize: '0.875rem',
    border: '1px solid #E5E7EB',
    padding: '12px 16px',
    maxWidth: 320,
  },
  '& .MuiTooltip-arrow': {
    color: '#FFFFFF',
    '&::before': {
      border: '1px solid #E5E7EB',
    },
  },
}));

export default CustomTooltip;
